module.exports = __webpack_public_path__ + "static/media/Launch_and_Recovery_System_01.79ee633a.jpg";